// extracted by mini-css-extract-plugin
module.exports = {"AppShell":"styles_AppShell__19H1N","AppShell_main":"styles_AppShell_main__30NqD","AppShell_content":"styles_AppShell_content__1tp3j"};